import { VAlert } from 'vuetify/lib/components/VAlert';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.one_user && _vm.is_new_user)?_c(VAlert,{attrs:{"app":"","type":"info","dense":"","icon":"mdi-account-star"}},[_c(VRow,{staticClass:"px-1",attrs:{"align":"center","justify":"space-between"}},[_c('span',[_c('strong',[_vm._v("Bem vindo")]),_vm._v(" \n        Para acessar todas as funcionalidades, solicite a um Administrador da empresa que adicione você a um departamento.\n      ")])])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }